import { createSelector } from 'reselect';

const userDashboardSelector = (state: TReduxState) => state.root.entities.dashboard;
export const selectConGptFilesPopover = createSelector(userDashboardSelector, (data) => data.conGptFilesPopover);
export const selectdoazGptFilesPopover = createSelector(userDashboardSelector, (data) => data.doazGptFilesPopover);

